import { Injectable } from '@angular/core';
import { StaffPayrollGroupModel } from './model/staff-payroll-group.model';
import { RequestData } from 'src/app/common/models/request-data.model';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
@Injectable({
  providedIn: 'root'
})
export class StaffPayrollGroupService {



  constructor(private http: HttpClient) { }

  getList(requestData:RequestData): Observable<any> {
    return this.http.post(environment.baseUrl+'/staff-payroll-group/get', requestData);

  }

  getById(id: number, shop_id: number): Observable<any> {
    return this.http.post(
      environment.baseUrl + '/staff-payroll-group/get/' + id + '/' + shop_id,
      ''
    );
  }
  downloadExcel(requestData: any): Observable<Blob> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
   // const url = 'http://yourdomain.com/api/customers/export'; // Adjust URL

    return this.http.post(environment.baseUrl + '/staff-payroll-group/export-list', requestData, { headers, responseType: 'blob' })
      .pipe(
        //catchError(this.handleError)
      );

  }

   /**
   * 
   * @param payrollInfo 
   * Calls the update API to insert/update the record
   */
   update(staffPayrollInfo: StaffPayrollGroupModel): Observable<any> {

      return this.http.post(environment.baseUrl+'/staff-payroll-group/update', staffPayrollInfo);

  }




}
